import { render, staticRenderFns } from "./tysfrzsq.vue?vue&type=template&id=250e9cc9&scoped=true&"
import script from "./tysfrzsq.vue?vue&type=script&lang=js&"
export * from "./tysfrzsq.vue?vue&type=script&lang=js&"
import style0 from "./tysfrzsq.vue?vue&type=style&index=0&id=250e9cc9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250e9cc9",
  null
  
)

export default component.exports